import { AbstractDimension } from '@orus.eu/dimensions'
import { type FrRcpwQuote, quoteV3ToSerializedQuoteData } from '@orus.eu/pricing'
import type { Result } from '@orus.eu/result'

export type FrRcpwQuoteFailure =
  | { type: 'temporary-wakam-fr-rcp-api-issue'; reason: string }
  | { type: 'unhandled-wakam-fr-rcp-api-error'; reason: string }
  | { type: 'activity-split-sum-incorrect' }
  | { type: 'total-revenue-over-two-million' }
  | { type: 'incompatible-revenue-limit' }
export type FrRcpwQuoteResult = Result<FrRcpwQuote, FrRcpwQuoteFailure>

export class FrRcpwQuoteDimension<NAME extends string> extends AbstractDimension<NAME, FrRcpwQuoteResult> {
  override formatToString(value: FrRcpwQuoteResult): string {
    if (value.type === 'failure') {
      return `NULL - ${value.problem.type}`
    }
    return quoteV3ToSerializedQuoteData(value.output)
  }
}

export const frRcpwQuoteDimension = new FrRcpwQuoteDimension({
  name: 'frRcpwQuote',
  displayKeys: { name: 'dimension_name_fr_rcpw_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
